export default __webpack_public_path__ + "static/media/karo.4884e714.png";